import { Box } from "@talentech/components";

const EditorSkeleton = () => {
  return (
    <Box paper spacing={2} flex className="placeholder-glow">
      <Box className="col-10" spacing={1}>
        <Box className="placeholder placeholder-lg col-12" />
        <Box className="placeholder col-12 mt-4" style={{
            height: "30vh"
        }} />
        <Box className="placeholder col-12 mt-4" style={{
            height: "30vh"
        }} />
      </Box>
      <Box className="col-2" spacing={1}>
        <Box className="placeholder col-12" style={{height: "80vh"}} />
      </Box>
    </Box>
  );
};

export default EditorSkeleton;
